import { UiText } from '@experiences/ui-common';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import clsx from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => createStyles({
    labelRoot: {
        alignItems: 'center',
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: '4px',
        margin: '0px',
        width: '100%',
        height: '56px',
        transition: 'background-color 0.2s ease',
    },
    labelHover: { '&:hover': { backgroundColor: `${theme.palette.semantic.colorBackgroundSecondary} !important` } },
    label: {
        display: 'flex',
        padding: '9px',
        alignItems: 'center',
        alignContent: 'center',
        width: '100%',
    },
    labelContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    icon: { margin: '2px 8px 0 2px' },
    serviceName: {
        fontWeight: 600,
        fontSize: '14px',
        color: theme.palette.text.primary,
    },
    serviceNameDisabled: {
        fontWeight: 600,
        fontSize: '14px',
        color: theme.palette.text.disabled,
    },
}));

interface IAllocationEnforcementServiceCardProps {
    serviceCode: string;
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
}

export const AllocationEnforcementServiceCard: React.FC<IAllocationEnforcementServiceCardProps> = ({
    serviceCode,
    checked,
    disabled,
    onChange,
}) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();
    return (
        <FormControlLabel
            labelPlacement="start"
            control={
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    data-cy={`stop-consumption-${serviceCode.replace(/\./g, '_')}`}
                />
            }
            label={
                <div className={classes.labelContent}>
                    <UiText className={disabled ? classes.serviceNameDisabled : classes.serviceName}>
                        {translate({ id: `CLIENT_CONSUMABLE_GRAPH_${serviceCode}` })}
                    </UiText>
                </div>
            }
            disabled={disabled}
            classes={{
                root: clsx(classes.labelRoot, !disabled && classes.labelHover),
                label: classes.label,
            }}
            data-cy={`allocation-enforcement-card-${serviceCode.replace(/\./g, '_')}`}
        />
    );
};
